import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
import { offerBullets } from '../data/content';
export function Offer() {
  return <section id="offer" className="scroll-mt-2 border-y-4 border-volt bg-graphite px-3 py-4 sm:px-6" data-id="element-118" data-mp="1mmh72e0sz8hy">
      <div className="mx-auto max-w-xl text-center" data-id="element-119" data-mp="1hph2y8nikfth">
        <p className="inline-block rounded-full bg-volt px-3 py-0.5 text-[0.68rem] font-black uppercase tracking-[0.2em] text-carbon sm:text-xs" data-id="element-120" data-mp="tyv51a784bx7">
          SPECIAL LAUNCH OFFER
        </p>
        <h2 className="mt-1.5 font-display text-[1.7rem] font-bold uppercase leading-none text-white sm:text-[2.4rem]" data-id="element-121" data-mp="p24q4q75nmdd">
          ⚡ GENERATOR <span className="text-volt" data-id="element-122" data-mp="yxeqzalthnpk">DIAGNOSTIC PRO™</span>
        </h2>
        <p className="mt-1 text-[0.68rem] font-bold uppercase tracking-wide text-steel sm:text-[0.84rem]" data-id="element-123" data-mp="z0app15hogf2">
          THE COMPLETE FAULT-FINDING SYSTEM FOR GENERATOR TECHNICIANS
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[260px] sm:max-w-[330px]" target="checkout" data-id="element-124" data-mp="2af7kkroctzuc" />

        <div className="mt-2 rounded-md border-2 border-volt bg-carbon px-3 py-2.5 text-left" data-id="element-125" data-mp="pmbfxskd704g">
          <p className="text-center font-display text-[1.05rem] font-bold uppercase tracking-wide text-volt sm:text-[1.25rem]" data-id="element-126" data-mp="ulenpkrqbkg4">
            Complete 6-in-1 System
          </p>
          <ul className="mt-1.5 grid gap-1 sm:grid-cols-2" data-id="element-127" data-mp="13iowmzh2qxhv">
            {offerBullets.map(b => <li key={b} className="flex items-start gap-1.5" data-id="element-128" data-mp="6vak3dejjkp4">
                <CheckCircle2Icon className="mt-[1px] h-3.5 w-3.5 shrink-0 text-volt" strokeWidth={2.5} aria-hidden="true" data-id="element-129" data-mp="bsao7irtyddl" />
                <span className="text-[0.76rem] leading-tight text-white sm:text-[0.86rem]" data-id="element-130" data-mp="ftm9jc3o8cfz">{b}</span>
              </li>)}
          </ul>
          <p className="mt-2.5 text-center text-[0.82rem] font-black uppercase leading-tight text-white sm:text-[1.02rem]" data-id="element-131" data-mp="3k8m24xkk8945">
            🔥 GET GENERATOR DIAGNOSTIC PRO™ TODAY —{' '}
            <span className="whitespace-nowrap rounded bg-volt px-1.5 text-carbon" data-id="element-132" data-mp="3o84kblkzy63a">$27 USD</span>
          </p>
          <div className="mt-2.5" data-id="element-133" data-mp="vde8h62r6466">
            <CTAButton label="⚡ GET INSTANT ACCESS" sub="Immediate Digital Access" target="checkout" data-id="element-134" data-mp="qhfl9lt5us7c" />
          </div>
          <p className="mt-2 text-center text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-135" data-mp="1548ty886czqk">
            🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}